import { Card, Col, message, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {loginInitiate } from "../../config/Redux/action";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.user.isLoading);
  let user = useSelector((state) => state.user.isLogin);
  const [input, setInput] = useState({
    email: '',
    password: ''
  })

  useEffect(() => {
    if (user === true) {
      navigate('/dashboard/shirt');
      message.success('you have successfully logged in', [3]);
    }
  }, [navigate, user]);

  const handleOnChange = (e) => {
    const {name, value} = e.target;
    setInput({...input, [name] : value})
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const {email, password} = input
    dispatch(loginInitiate(email, password))
    setInput({
      email: '',
      password: '',
    });
  }

  return (
    <div className='auth'>
      <Row>
        <Col span={12}>
          <Card title={<h1 className='card-title'>Login</h1>} className='card'>
            <form onSubmit={handleSubmit}>
              <div className='form-group'>
                <label>Email</label>
                <input
                  required
                  type={'email'}
                  name='email'
                  value={input.email}
                  onChange={handleOnChange}
                />
              </div>
              <div className='form-group'>
                <label>Password</label>
                <input
                  required
                  type={'password'}
                  name='password'
                  value={input.password}
                  onChange={handleOnChange}
                />
              </div>
              {loading ? (
                <button type='primary' size='large' className='btn-register'>
                  Loading...
                </button>
              ) : (
                <button type='primary' size='large' className='btn-register'>
                  Login
                </button>
              )}
            </form>
            {/* <Link to='/register'>
              <div className='choose-register'>
                <p>
                  Belum punya akun ? <span>Register</span>
                </p>
              </div>
            </Link> */}
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Login;